var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 2.8125H17.0688C17.7619 2.8125 18.3188 3.37 18.3188 4.0625V13.4375C18.3188 14.13 17.7619 14.6875 17.0688 14.6875H15.5125L15.4962 16.875L12.9987 14.6875H4.5625C3.87 14.6875 3.3125 14.13 3.3125 13.4375V4.0625C3.3125 3.37 3.87 2.8125 4.5625 2.8125Z",
    stroke: "#FAFBFA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80371 13.1448V9.70598H7.05371V13.1448M7.06059 13.1448V11.581H8.31059V13.1448M8.31746 13.1448V8.43164H9.56746V13.1448",
    stroke: "#FAFBFA",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 13.1455V9.7067H10.8086V13.1455M10.8142 13.1455V7.18983H12.0642L12.0498 13.1461M12.0586 13.1455V9.7067H13.3086V13.1455M13.3142 13.1455V11.5724H14.5623V13.1455M14.5673 13.1249V4.69922H15.8098V13.1249",
    stroke: "#FAFBFA",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8653 4.29202C11.201 5.16995 10.214 5.89945 9.06414 6.3623C7.91432 6.82515 6.66915 6.99421 5.53051 6.84204",
    stroke: "#FAFBFA",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4961 4.07031H12.0586V5.63281",
    stroke: "#FAFBFA",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/icon-sales.88ac0b55ad57cd70683206c403eae4fe.svg";
export { ForwardRef as ReactComponent };